import appGlobalScript from '/codebuild/output/src1930800506/src/packages/navigation/scripts/global.ts';
export const globalScripts = appGlobalScript;
